var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1644.2 200.4",
    style: {
      enableBackground: "new 0 0 1644.2 200.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,35.6C27,35.6,0,61.8,0,100.7c0,39,25.9,64.2,66.1,64.2c17.3,0,29-6.8,37.1-13.2l0.3,11h30.7v-62 C134.2,61.8,107.2,35.6,67.1,35.6z M101.6,109c-2.7,14.8-17.1,25.9-33.4,25.9c-20.5,0-33.7-13.4-33.7-34.2 c0-20.8,13.2-34.2,33.7-34.2c16.3,0,33.7,9,33.7,34.2C102,101.3,101.9,107.7,101.6,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.6,100.7v99.7h30.7l0.3-48.7c8.1,6.4,19.8,13.2,37.1,13.2c40.1,0,66.1-25.2,66.1-64.2 c0-38.9-27-65-67.1-65C177.6,35.6,150.6,61.8,150.6,100.7z M182.8,100.7c0-25.2,17.4-34.2,33.7-34.2c20.5,0,33.7,13.4,33.7,34.2 c0,20.8-13.2,34.2-33.7,34.2c-16.3,0-30.6-11.1-33.4-25.9C182.9,107.7,182.8,101.3,182.8,100.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.3,35.6c-40.1,0-67.1,26.1-67.1,65c0,39,25.9,64.2,66.1,64.2c17.3,0,29-6.8,37.1-13.2l0.3,11h30.7v-62 C435.4,61.8,408.4,35.6,368.3,35.6z M402.8,109c-2.7,14.8-17.1,25.9-33.4,25.9c-20.5,0-33.7-13.4-33.7-34.2 c0-20.8,13.2-34.2,33.7-34.2c16.3,0,33.7,9,33.7,34.2C403.1,101.3,403,107.7,402.8,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M586,99.9V0.1h-30.7l-0.3,48.7c-8.1-6.4-19.8-13.2-37.1-13.2c-40.1,0-66.1,25.2-66.1,64.2 c0,38.9,27,65,67.1,65S586,138.8,586,99.9z M553.7,99.9c0,25.2-17.4,34.2-33.7,34.2c-20.5,0-33.7-13.4-33.7-34.2 c0-20.8,13.2-34.2,33.7-34.2c16.3,0,30.6,11.1,33.4,25.9C553.6,92.8,553.7,99.2,553.7,99.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M633,54.3l-0.3-13.1h-30.3v53.5v70.1H636v-62.8c0-0.7,0.3-7,0.3-8.3c0-21.4,15.6-25.9,31.9-25.9 c4.2,0,9.1,0.7,11.1,1.5V39C663.2,37.2,643.3,38.3,633,54.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.9,41.5H697v123.4h33.9V41.5z M714.2,0c-11.1,0-18.6,7.2-18.6,18c0,10.8,7.5,18,18.6,18 c11.1,0,18.6-7.2,18.6-18C732.9,7.2,725.4,0,714.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M883.4,164.9V95.2c0-37.7-24.8-57.3-61.9-57.3c-17.3,0-31.8,6.8-39.9,13.2l-0.3-9.8h-32.1v53.5v70.1h33.6 v-62.8c0-0.7,0.1-7.1,0.3-8.3c2.7-14.8,20-25.9,36.3-25.9c18.3,0,29.4,10.3,29.4,31.1v66H883.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1034,164.9V95.2c0-37.7-24.8-57.3-61.9-57.3c-17.3,0-31.8,6.8-39.9,13.2l-0.3-48.7h-32.1v92.4v70.1h33.6 v-62.8c0-0.7,0.1-7.1,0.3-8.3c2.7-14.8,20-25.9,36.3-25.9c18.3,0,29.4,10.3,29.4,31.1v66H1034z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1183.7,99.9c0-38.9-26-65-66.1-65c-40.1,0-67.1,26.1-67.1,65c0,38.9,27,65,67.1,65c31.1,0,54.3-15.7,63.2-41 h-38.3c-5.2,6.6-12.6,10.2-24.8,10.2c-15.5,0-27.7-8.3-31.8-21.9l97,0C1183.3,108.3,1183.7,104.2,1183.7,99.9z M1117.5,65.7 c12.5,0,26.4,5.7,31.3,20.8H1086C1090.4,73.5,1102.4,65.7,1117.5,65.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1200,
    y: 86.4,
    className: "st0",
    width: 80.7,
    height: 25.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1444.7,37.9c-15.6,0-30.4,5.3-40.4,18.9c-8.9-13.3-24-18.9-41.5-18.9c-12.9,0-25.3,3.6-34.8,12.6l-0.3-9.2 h-30.5v60.8v62.8h33.6v-62.8V89.4c0.3-14.2,9.6-21.5,25.6-21.5c10,0,21.8,4.5,21.8,21.4v75.7h34.6V89.2c0-0.5,0-0.9,0-1.4 c0.9-13.2,10.1-20,25.5-20c10,0,21.8,4.5,21.8,21.4v75.7h34.6V89.2C1494.6,52.3,1472.5,37.9,1444.7,37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1644.2,99.9c0-38.9-26-65-66.1-65s-67.1,26.1-67.1,65c0,38.9,27,65,67.1,65c31.1,0,54.3-15.7,63.2-41h-38.3 c-5.2,6.6-12.6,10.2-24.8,10.2c-15.5,0-27.7-8.3-31.8-21.9l97,0C1643.8,108.3,1644.2,104.2,1644.2,99.9z M1578,65.7 c12.5,0,26.4,5.7,31.3,20.8h-62.8C1550.9,73.5,1563,65.7,1578,65.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4958be920c38b9c7c37af8195a1c2fe1.svg";
export { ForwardRef as ReactComponent };